import Component from "grimoirejs/ref/Node/Component";
import MeshRenderer from "grimoirejs-fundamental/ref/Components/MeshRendererComponent";
export default class GLTFVertexMorpher extends Component {
    $mount() {
        this._meshComponent = this.node.getComponent(MeshRenderer);
        this._meshComponent.geometry.then(g => this._morphTarget = g);
        this.getAttributeRaw("weights").watch(v => {
            if (this._morphTarget) {
                this._morphTarget.setWeight(v);
            }
        });
    }
}
GLTFVertexMorpher.attributes = {
    weights: {
        default: [],
        converter: "NumberArray"
    }
};



// WEBPACK FOOTER //
// ./src/Components/GLTFVertexMorpher.ts